import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "تقريب الأعداد أونلاين - حاسبة التقريب الدقيقة";
const DESCRIPTION =
  "تحسب هذه الآلة الحاسبة تقريب الرقم إلى أقرب عدد صحيح أو أقرب قيمة عشرية بناءً على مستوى الدقة المحدد، سواء كان تقريب العدد لأقرب 10 أو 100 أو 1000. مثالية لحساب النتائج التقريبية في العمليات الحسابية المختلفة، وتدعم تقريب الأرقام العشرية مع تقريب الأعداد لأقرب عشرة أو مئة. تتميز بواجهة مستخدم سهلة وبديهية، وتوفر نتائج دقيقة وسريعة.";
const KEYWORDS =
  "تقريب، حاسبة، تقريب العدد، تقريب الأعداد، التقريب الى اقرب عشرة، التقريب الى اقرب مئة، التقريب لأقرب 10، التقريب لأقرب 100، التقريب لأقرب 1000";
const OG_URL = "https://do-calculate.com/calculator/ar/rounding-calculator";
const RoundingCalculator = () => {
  const [number, setNumber] = useState("");
  const [precision, setPrecision] = useState(0);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const roundNumber = (num, precision) => {
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
  };
  const handleCalculate = () => {
    try {
      if (!number) {
        throw new Error("الرجاء إدخال رقم.");
      }
      const num = parseFloat(number);
      if (isNaN(num)) throw new Error("الرجاء إدخال رقم صحيح.");
      const roundedValue = roundNumber(num, precision);
      setResult(roundedValue);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هذه الحاسبة تساعدك في تقريب الأعداد إلى أقرب عدد صحيح أو إلى
                  أقرب قيمة عشرية حسب احتياجاتك. سواء كنت تحتاج إلى تقريب العدد
                  لأقرب 10، 100، أو 1000، فإن هذه الأداة تسهم في تبسيط الأرقام
                  وتجعل الحسابات أكثر سهولة. على سبيل المثال، تقريب الرقم 234
                  إلى أقرب عشرة يعطيك 230، بينما تقريب 1,478 إلى أقرب مئة يعطيك
                  1,500. من خلال استخدام هذه الأساليب في تقريب الأعداد، يمكنك
                  الحصول على نتائج دقيقة وسريعة تتناسب مع احتياجاتك اليومية،
                  سواء في الحسابات المالية، قياسات المسافات، أو تقييمات الوزن
                  والطول.
                </p>
              </div>
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة التقريب</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">أدخل الرقم</label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 123.456"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        className="form-control"
                        style={{ width: "300px" }}
                      />
                    </div>
                    <div className="form-group d-flex align-items-center mt-3">
                      <b>
                        <label className="form-label ms-2">
                          اختر مستوى الدقة
                        </label>
                      </b>
                      <select
                        value={precision}
                        onChange={(e) => setPrecision(Number(e.target.value))}
                        className="form-select"
                        style={{ width: "300px" }}
                      >
                        <option value="">عشري</option>
                        <option value={0}>آحاد (0)</option>
                        <option value={1}>عشرات (1)</option>
                        <option value={2}>مئات (2)</option>
                        <option value={3}>ألوف (3)</option>
                        <option value={4}>عشرات الألوف (4)</option>
                        <option value={5}>مئات الألوف (5)</option>
                        <option value={6}>مليون (6)</option>
                        <option value="" className="no-select">أعداد صحيحة</option>
                        <option value={-1}>عشرات (-1)</option>
                        <option value={-2}>مئات (-2)</option>
                        <option value={-3}>ألوف (-3)</option>
                        <option value={-6}>مليون (-6)</option>
                        <option value="">كسور</option>
                        <option value={1 / 2}>1/2</option>
                        <option value={1 / 4}>1/4</option>
                        <option value={1 / 8}>1/8</option>
                        <option value={1 / 16}>1/16</option>
                        <option value={1 / 32}>1/32</option>
                        <option value={1 / 64}>1/64</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      result !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">النتيجة: {result}</p>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>التقريب</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب هو عملية تعديل رقم إلى قيمة أبسط أو أقرب لتسهيل
                        العمليات الحسابية أو تقديم تقديرات أسهل. يمكن أن يكون
                        التقريب إلى أقرب عدد صحيح أو إلى أقرب قيمة عشرية.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Tenths (1)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من عشرة يعني الاحتفاظ برقم واحد بعد
                        الفاصلة العشرية. هذا مفيد عندما تحتاج إلى دقة أكبر من
                        الأعداد الصحيحة ولكن ليست دقيقة جدًا. على سبيل المثال،
                        تقريب 2.76 إلى أقرب جزء من عشرة يكون 2.8، بينما تقريب
                        2.74 يكون 2.7. يتم استخدام هذه الطريقة في القياسات التي
                        تتطلب دقة معقولة مثل قياس الطول أو الوزن.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Hundredths (2)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من مئة يعني الاحتفاظ برقمين بعد
                        الفاصلة العشرية. هذا المستوى من الدقة مفيد في العديد من
                        المجالات مثل المحاسبة والهندسة حيث تحتاج الأرقام إلى أن
                        تكون دقيقة للغاية. على سبيل المثال، تقريب 2.765 إلى أقرب
                        جزء من مئة يكون 2.77، بينما تقريب 2.764 يكون 2.76.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Thousandths (3)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من ألف يعني الاحتفاظ بثلاثة أرقام
                        بعد الفاصلة العشرية. هذا المستوى من الدقة يستخدم في
                        العلوم والطب حيث تكون الحاجة إلى دقة عالية جدًا. على
                        سبيل المثال، تقريب 2.7654 إلى أقرب جزء من ألف يكون
                        2.765، بينما تقريب 2.7656 يكون 2.766.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Ten Thousandths (4)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من عشرة آلاف يعني الاحتفاظ بأربعة
                        أرقام بعد الفاصلة العشرية. هذا المستوى من الدقة يمكن أن
                        يكون ضروريًا في المجالات التي تتطلب قياسات فائقة الدقة
                        مثل الفيزياء النظرية والتحليل المالي الدقيق. على سبيل
                        المثال، تقريب 2.76543 إلى أقرب جزء من عشرة آلاف يكون
                        2.7654، بينما تقريب 2.76545 يكون 2.7655.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>
                        Hundred Thousandths (5)
                      </h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من مئة ألف يعني الاحتفاظ بخمسة
                        أرقام بعد الفاصلة العشرية. هذا المستوى من الدقة يستخدم
                        في التطبيقات العلمية والهندسية المتقدمة حيث تكون الحاجة
                        إلى دقة متناهية. على سبيل المثال، تقريب 2.765432 إلى
                        أقرب جزء من مئة ألف يكون 2.76543، بينما تقريب 2.765435
                        يكون 2.76544.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Millionths (6)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من مليون يعني الاحتفاظ بستة أرقام
                        بعد الفاصلة العشرية. هذا المستوى من الدقة غالبًا ما يكون
                        ضروريًا في الأبحاث العلمية والتطبيقات الهندسية التي
                        تتطلب دقة استثنائية. على سبيل المثال، تقريب 2.7654321
                        إلى أقرب جزء من مليون يكون 2.765432، بينما تقريب
                        2.7654326 يكون 2.765433.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Tens (-1)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب عشرات يعني تقريب الرقم إلى أقرب مضاعف
                        للعشرة. هذا النوع من التقريب يستخدم لتبسيط الأرقام
                        الكبيرة أو عند التعامل مع قيم تقريبية لا تحتاج إلى دقة
                        عالية. على سبيل المثال، تقريب 25 إلى أقرب عشرات يكون 30،
                        بينما تقريب 24 يكون 20. هذه الطريقة شائعة في التقديرات
                        السريعة والميزانيات.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Hundreds (-2)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب مئات يعني تقريب الرقم إلى أقرب مضاعف
                        للمائة. يستخدم هذا النوع من التقريب عند التعامل مع
                        الأرقام الكبيرة جدًا، أو عندما لا تكون هناك حاجة إلى
                        الدقة الدقيقة. على سبيل المثال، تقريب 250 إلى أقرب مئات
                        يكون 300، بينما تقريب 240 يكون 200. هذا النوع من التقريب
                        مفيد في المجالات المالية والاقتصادية.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Thousands (-3)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب آلاف يعني تقريب الرقم إلى أقرب مضاعف
                        للألف. هذا النوع من التقريب يستخدم عند التعامل مع
                        الأرقام الكبيرة جدًا حيث تكون الدقة الدقيقة غير ضرورية.
                        على سبيل المثال، تقريب 2750 إلى أقرب آلاف يكون 3000،
                        بينما تقريب 2250 يكون 2000. هذا النوع من التقريب شائع في
                        التحليل الاقتصادي والتقديرات السكانية.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Millions (-6)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب ملايين يعني تقريب الرقم إلى أقرب مضاعف
                        للمليون. هذا النوع من التقريب يستخدم عند التعامل مع
                        الأرقام الكبيرة جدًا حيث تكون الدقة الدقيقة غير ضرورية.
                        على سبيل المثال، تقريب 2,750,000 إلى أقرب مليون يكون
                        3,000,000، بينما تقريب 2,250,000 يكون 2,000,000. هذا
                        النوع من التقريب شائع في التحليل الاقتصادي والتقديرات
                        السكانية.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/2</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب نصف يعني تقريب الرقم إلى أقرب مضاعف
                        لنصف. هذا النوع من التقريب يستخدم لتبسيط الأرقام بشكل
                        يجعلها أسهل للفهم دون فقدان الكثير من الدقة. على سبيل
                        المثال، تقريب 2.7 إلى أقرب نصف يكون 2.5، بينما تقريب 2.8
                        يكون 3. هذا النوع من التقريب مفيد في الحياة اليومية حيث
                        تستخدم الكسور البسيطة بشكل متكرر.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/4</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب ربع يعني تقريب الرقم إلى أقرب مضاعف
                        للربع. هذا النوع من التقريب يستخدم لتبسيط الأرقام إلى
                        كسور مألوفة، مما يسهل العمليات الحسابية اليومية. على
                        سبيل المثال، تقريب 2.6 إلى أقرب ربع يكون 2.5، بينما
                        تقريب 2.7 يكون 2.75. هذا النوع من التقريب مفيد في الطهي
                        والقياسات البسيطة.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/8</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب ثمن يعني تقريب الرقم إلى أقرب مضاعف
                        للثمن. يستخدم هذا النوع من التقريب لتبسيط الأرقام في
                        القياسات الدقيقة ولكنه يبقيها مفهومة. على سبيل المثال،
                        تقريب 2.625 إلى أقرب ثمن يكون 2.625، بينما تقريب 2.6375
                        يكون 2.625. هذا النوع من التقريب يستخدم في النجارة
                        والهندسة.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/16</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب سدس عشر يعني تقريب الرقم إلى أقرب مضاعف
                        للسدس عشر. يستخدم هذا النوع من التقريب عند الحاجة إلى
                        دقة عالية في الأرقام دون الدخول في تعقيدات الكسور
                        العشرية الطويلة. على سبيل المثال، تقريب 2.0625 إلى أقرب
                        سدس عشر يكون 2.0625، بينما تقريب 2.06875 يكون 2.0625.
                        هذا النوع من التقريب يستخدم في الأعمال الدقيقة مثل صناعة
                        الساعات.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/32</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من اثنين وثلاثين يعني تقريب الرقم
                        إلى أقرب مضاعف للجزء من اثنين وثلاثين. هذا المستوى من
                        الدقة يستخدم في المجالات التي تتطلب دقة متناهية ولكن مع
                        استخدام كسور بسيطة. على سبيل المثال، تقريب 2.03125 إلى
                        أقرب جزء من اثنين وثلاثين يكون 2.03125، بينما تقريب
                        2.034375 يكون 2.03125. هذا النوع من التقريب يستخدم في
                        الأعمال الدقيقة والمجالات العلمية.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>1/64</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        التقريب إلى أقرب جزء من أربعة وستين يعني تقريب الرقم إلى
                        أقرب مضاعف للجزء من أربعة وستين. هذا المستوى من الدقة
                        يستخدم في المجالات التي تتطلب دقة متناهية للغاية. على
                        سبيل المثال، تقريب 2.015625 إلى أقرب جزء من أربعة وستين
                        يكون 2.015625، بينما تقريب 2.0234375 يكون 2.015625. هذا
                        النوع من التقريب يستخدم في الفيزياء النظرية والأبحاث
                        الدقيقة.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
    </div>
  );
};
export default RoundingCalculator;
